import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M17.4399 15.37C17.2499 15.37 17.0599 15.3 16.9099 15.15C16.6199 14.86 16.6199 14.38 16.9099 14.09L18.9399 12.06L16.9099 10.03C16.6199 9.74 16.6199 9.26 16.9099 8.97C17.1999 8.68 17.6799 8.68 17.9699 8.97L20.5299 11.53C20.8199 11.82 20.8199 12.3 20.5299 12.59L17.9699 15.15C17.8199 15.3 17.6299 15.37 17.4399 15.37Z",
  fill: "#1F2937",
  class: "icon-fill icon-fill_logout-path"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19.93 12.81H9.76001C9.35001 12.81 9.01001 12.47 9.01001 12.06C9.01001 11.65 9.35001 11.31 9.76001 11.31H19.93C20.34 11.31 20.68 11.65 20.68 12.06C20.68 12.47 20.34 12.81 19.93 12.81Z",
  fill: "#1F2937",
  class: "icon-fill icon-fill_logout-path"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11.76 20.75C6.61001 20.75 3.01001 17.15 3.01001 12C3.01001 6.85 6.61001 3.25 11.76 3.25C12.17 3.25 12.51 3.59 12.51 4C12.51 4.41 12.17 4.75 11.76 4.75C7.49001 4.75 4.51001 7.73 4.51001 12C4.51001 16.27 7.49001 19.25 11.76 19.25C12.17 19.25 12.51 19.59 12.51 20C12.51 20.41 12.17 20.75 11.76 20.75Z",
  fill: "#1F2937",
  class: "icon-fill icon-fill_logout-path"
}, null, -1)

import SvgWrapper from '@C/ui/icons/SvgWrapper.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'IconLogout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SvgWrapper, {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3
    ]),
    _: 1
  }))
}
}

})